/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string } from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const AXsmallcard = (props) => {
    const { className } = props;
    return (
        <SvgIcon className={className} viewBox="0 0 36 24">
            <defs />
            <g id="smallcard_amex" fillRule="evenodd" clipRule="evenodd">
                <rect x="1.151" y="0.5" width="35" height="23.6857" rx="3.5" fill="#1F72CD" stroke="#D9D9D9" />
                <path d="M7.10493 8.74286L3.73669 16.1967H7.76894L8.26883 15.0082H9.41144L9.91132 16.1967H14.3497V15.2896L14.7452 16.1967H17.0411L17.4365 15.2704V16.1967H26.6672L27.7896 15.0391L28.8405 16.1967L33.5816 16.2062L30.2027 12.4906L33.5816 8.74286H28.9141L27.8215 9.87905L26.8036 8.74286H16.7619L15.8996 10.6667L15.0171 8.74286H10.9933V9.61905L10.5456 8.74286H7.10493ZM7.88515 9.80131H9.85066L12.0848 14.8558V9.80131H14.2379L15.9636 13.4253L17.5539 9.80131H19.6963V15.1499H18.3927L18.3821 10.9588L16.4816 15.1499H15.3154L13.4043 10.9588V15.1499H10.7225L10.2141 13.9508H7.46734L6.95997 15.1488H5.52311L7.88515 9.80131ZM26.1896 9.80131H20.889V15.1467H26.1075L27.7896 13.3752L29.4108 15.1467H31.1055L28.6423 12.4895L31.1055 9.80131H29.4843L27.8108 11.5525L26.1896 9.80131ZM8.84128 10.7063L7.93633 12.8423H9.74518L8.84128 10.7063ZM22.1979 11.8851V10.9087V10.9078H25.5054L26.9485 12.4693L25.4414 14.0393H22.1979V12.9734H25.0897V11.8851H22.1979Z" fill="white" />
            </g>
        </SvgIcon>
    );
};

AXsmallcard.defaultProps = { className: '' };

AXsmallcard.propTypes = { className: string };

export default AXsmallcard;
